export default __webpack_public_path__ + "static/media/foto5.b883fba7.jpg";